import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_OCR } from "../../config/config.json";
import { decryptStorage } from 'utils/utils';
const baseQuery = fetchBaseQuery({
    baseUrl: API_OCR,
    extraOptions: { timeout: 30000 },
    prepareHeaders: (headers) => {
        headers.set('content-type', 'application/json');
        headers.set('accept', '*/*');
        headers.set('Accept-Encoding', 'gzip, deflate, br');
        headers.set('Connection', 'keep-alive');
        const token = decryptStorage(localStorage.getItem("token"))

        if (token) headers.set('Authorization', `Bearer ${token}`)
        return headers;
    }
});

export const microserviceDocReviewAPI = createApi({
    reducerPath: 'microserviceDocReviewAPI',
    baseQuery,
    endpoints: () => ({})
});